import React, { forwardRef } from 'react';

import type { BackpackStatesNullableParameter } from '@vlabs/api/luna-api/model';
import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';

import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

function BackpackFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { filters, updateFilters } = useEventListFilters();

  const selectedStates = filters.backpack_states ?? [];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedStates.length === 0}
      onClickReset={() => updateFilters({ backpack_states: undefined })}
      ref={ref}
    >
      <OptionsFilter
        isSearchable={false}
        name="backpack_states"
        onChange={(value) => updateFilters({
          backpack_states: value.length > 0
            ? (value as unknown as BackpackStatesNullableParameter)
            : undefined,
        })}
        options={EVENT_ENUMS.ACCESSORIES.BACKPACK.raw}
        value={selectedStates as unknown as string[]}
      />
    </PopoverWithButton>
  );
}

const BackpackFilterPopoverWithRef = forwardRef(BackpackFilterPopover);
export { BackpackFilterPopoverWithRef as BackpackFilterPopover };
